<div class="learning-assistant">
    <!-- Contenido principal con scroll -->
    <div class="learning-assistant__content" #contentContainer>
        <!-- Contenedor de mensajes (burbujas del chat) -->
        <div class="learning-assistant__messages" *ngIf="messages.length > 0 && !selectedCourse">
            <ng-container *ngFor="let msg of messages">
                <div
                    class="learning-assistant__message"
                    [class.user]="msg.role === 'user'"
                >
                    <!-- Avatar -->
                    <div class="learning-assistant__avatar" [class.user]="msg.role === 'user'">
                        <svg *ngIf="msg.role !== 'user'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"/>
                            <path d="M12 6v6l4 2"/>
                        </svg>
                        <svg *ngIf="msg.role === 'user'" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                            <circle cx="12" cy="7" r="4"/>
                        </svg>
                    </div>

                    <!-- Burbuja de mensaje -->
                    <div
                        class="learning-assistant__bubble"
                        [class.user]="msg.role === 'user'"
                        [innerHTML]="msg.content"
                    ></div>
                </div>

                <!-- Recomendaciones asociadas al mensaje -->
                <div *ngIf="msg?.type === 'course-suggestion' && msg?.courses && msg.courses.length > 0"
                     class="learning-assistant__courses-list">
                <div
                    *ngFor="let course of msg.courses; let i = index"
                    class="learning-assistant__course-card"
                    [style.animation-delay]="(i * 0.1) + 's'"
                    (click)="selectCourse(course)"
                    role="button"
                    tabindex="0"
                >
                    <div class="course-card-inner">
                        <div class="course-header">
                            <h4>{{ course.title }}</h4>
                            <span class="level-badge" [class]="'level-' + course.level">
                                {{ course.level | uppercase }}
                            </span>
                        </div>

                        <p class="course-description">{{ course.description }}</p>

                        <div class="course-footer">
                            <span class="duration">
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="12" cy="12" r="10"></circle>
                                    <polyline points="12 6 12 12 16 14"></polyline>
                                </svg>
                                {{ course.duration }}
                            </span>
                            <button
                                class="learning-assistant__course-btn"
                                (click)="selectCourse(course); $event.stopPropagation()"
                            >
                                {{ 'chat.learning.view-details' | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5l7 7-7 7"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            </ng-container>
        </div>

        <!-- Vista de detalles del curso seleccionado -->
        <div *ngIf="selectedCourse" class="learning-assistant__course-detail">
            <button class="learning-assistant__back-btn" (click)="backToList()">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="19" y1="12" x2="5" y2="12"></line>
                    <polyline points="12 19 5 12 12 5"></polyline>
                </svg>
                {{ 'chat.learning.back' | translate }}
            </button>

            <div class="learning-assistant__course-card-detail">
                <div class="course-detail-header">
                    <h3>{{ selectedCourse.title }}</h3>
                    <span class="badge" [class]="'badge-' + selectedCourse.level">
                        {{ selectedCourse.level | uppercase }}
                    </span>
                </div>

                <p class="description">{{ selectedCourse.description }}</p>

                <div class="course-meta">
                    <div class="meta-item">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <polyline points="12 6 12 12 16 14"></polyline>
                        </svg>
                        <span>{{ selectedCourse.duration }}</span>
                    </div>
                    <div
                        class="meta-item"
                        *ngIf="selectedCourse.providerNames && selectedCourse.providerNames.length > 0"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                            <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span>{{ selectedCourse.providerNames.join(", ") }}</span>
                    </div>
                    <div class="meta-item" *ngIf="selectedCourse.locale">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <circle cx="12" cy="12" r="10"></circle>
                            <line x1="2" y1="12" x2="22" y2="12"></line>
                            <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"></path>
                        </svg>
                        <span>{{ selectedCourse.locale | uppercase }}</span>
                    </div>
                </div>

                <div
                    class="skills-section"
                    *ngIf="selectedCourse.skills && selectedCourse.skills.length > 0"
                >
                    <div class="skills-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon>
                        </svg>
                        <strong>{{ 'chat.learning.skills' | translate }}</strong>
                    </div>
                    <div class="skills-list">
                        <span *ngFor="let skill of selectedCourse.skills" class="skill-tag">
                            {{ skill }}
                        </span>
                    </div>
                </div>

                <!-- Tendencias del mercado -->
                <div class="info-section" *ngIf="selectedCourse.marketTrends">
                    <div class="info-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <line x1="12" y1="20" x2="12" y2="10"></line>
                            <line x1="18" y1="20" x2="18" y2="4"></line>
                            <line x1="6" y1="20" x2="6" y2="16"></line>
                        </svg>
                        <strong>{{ 'chat.learning.market-trends' | translate }}</strong>
                    </div>
                    <p class="info-content">{{ selectedCourse.marketTrends }}</p>
                </div>

                <!-- Expansión profesional -->
                <div class="info-section" *ngIf="selectedCourse.professionalExpansion">
                    <div class="info-header">
                        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                            <circle cx="8.5" cy="7" r="4"></circle>
                            <polyline points="17 11 19 13 23 9"></polyline>
                        </svg>
                        <strong>{{ 'chat.learning.opportunities' | translate }}</strong>
                    </div>
                    <p class="info-content">{{ selectedCourse.professionalExpansion }}</p>
                </div>

                <button
                    class="learning-assistant__subscribe-btn"
                    (click)="subscribeToCourse(selectedCourse)"
                    [disabled]="isSubscribing"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" *ngIf="!isSubscribing">
                        <path d="M5 12h14"></path>
                        <path d="M12 5l7 7-7 7"></path>
                    </svg>
                    <span class="spinner" *ngIf="isSubscribing"></span>
                    {{ isSubscribing ? ('chat.learning.subscribing' | translate) : ('chat.learning.subscribe' | translate) }}
                </button>
            </div>
        </div>

        <!-- Loader de búsqueda -->
        <div *ngIf="isLoading" class="learning-assistant__loader">
            <div class="loader-content">
                <div class="ai-icon">
                    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                        <path d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2Z"/>
                        <path d="M12 6v6l4 2"/>
                    </svg>
                </div>
                <div class="typing-dots">
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <p class="loader-text">{{ 'chat.learning.searching' | translate }}</p>
            </div>
        </div>

    </div>

    <!-- Input para consulta del usuario (fijo en la parte inferior) -->
    <div class="learning-assistant__input-section">
        <div class="input-wrapper">
            <textarea
                #userInput
                [(ngModel)]="userQuery"
                (keypress)="onKeyPress($event)"
                [placeholder]="'chat.learning.input.placeholder' | translate"
                class="learning-assistant__input"
                rows="1"
                [disabled]="isLoading"
            ></textarea>
            <button
                class="learning-assistant__send-btn"
                (click)="sendQuery()"
                [disabled]="!userQuery.trim() || isLoading"
                [attr.aria-label]="isLoading ? ('chat.learning.loading-aria' | translate) : ('chat.learning.send-aria' | translate)"
            >
                <svg *ngIf="!isLoading" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <line x1="22" y1="2" x2="11" y2="13"></line>
                    <polygon points="22 2 15 22 11 13 2 9 22 2"></polygon>
                </svg>
                <span class="spinner" *ngIf="isLoading"></span>
            </button>
        </div>
    </div>
</div>
